import { Help } from "@mui/icons-material";
import { Box, Button, InputAdornment, MenuItem, TextField, Tooltip, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { gateway } from "../gateway";
import { LoaderComponent } from "./Loader";
import { BaseDialog } from "./common/BaseDialog";

const styles = {
  titleSx: {
    fontWeight: "bold",
  },
  contentSx: { textAlign: "center", color: "var(--fx-surface-text, #0F172A)" },
  actionSx: {
    justifyContent: "center",
  },
  btnCloseSx: {
    backgroundColor: "grey",
    color: "white",
    "&:hover": { backgroundColor: "var(--fx-surface-sidebar, #233044)" },
    margin: "0 8px",
  },
};

export const CreatePromoDiscount = () => {
  const [basePlans, setBasePlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState();
  const [open, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [planName, setPlanName] = useState("");
  const [promoCode, setPromoCode] = useState("");
  const navigate = useNavigate();

  const token = sessionStorage.getItem("token");

  const getAllPlans = async () => {
    try {
      const plansResponse = await gateway.get("/paypal/plans", {
        headers: {
          Authorization: `${token}`,
        },
      });
      const plans = plansResponse?.data?.data.filter((item) => item.promoCodeDiscount === null && item.paypalPlanId);
      if (plans) setBasePlans(plans);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelectPlan = async (e) => {
    try {
      const planResponse = await gateway.get(`paypal/plans/${e.target.value}`, {
        headers: {
          Authorization: `${token}`,
        },
      });
      setSelectedPlan(planResponse.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  function formatCurrency(value) {
    let formattedValue = Number(value).toFixed(2);
    let [integer, decimal] = formattedValue.split(".");
    integer = integer.padStart(2, "0");
    return `${integer}.${decimal}`;
  }

  const handleOpenDialog = () => {
    setOpen(false);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    navigate("/business");
  };

  useEffect(() => {
    getAllPlans();
  }, []);

  const createPromoDiscount = async (event) => {
    try {
      //setOpen(true);
      event.preventDefault();
      const data = new FormData(event.currentTarget);
      const promoData = {
        name: `${selectedPlan.name}`,
        promoCodeDiscount: data.get("promoCode"),
        price: data.get("price"),
        intervalCount: data.get("intervalCount"),
      };
      setPromoCode(promoData.promoCodeDiscount);
      setPlanName(promoData.name);
      const planPrice = formatCurrency(promoData.price);
      const planData = {
        product_id: selectedPlan.product.paypalId,
        promoCodeDiscount: promoData.promoCodeDiscount,
        description: selectedPlan.description,
        status: selectedPlan.status,
        billing_cycles: [
          {
            frequency: {
              interval_unit: selectedPlan.billing_cycles[0].frequency.interval_unit,
              interval_count: promoData.intervalCount,
            },
            tenure_type: "TRIAL",
            sequence: 1,
            total_cycles: 1,
            pricing_scheme: {
              fixed_price: {
                value: planPrice,
                currency_code: selectedPlan.billing_cycles[0].pricing_scheme.fixed_price.currency_code,
              },
            },
          },
          {
            frequency: {
              interval_unit: selectedPlan.billing_cycles[0].frequency.interval_unit,
              interval_count: selectedPlan.billing_cycles[0].frequency.interval_count,
            },
            tenure_type: selectedPlan.billing_cycles[0].tenure_type,
            sequence: 2,
            total_cycles: selectedPlan.billing_cycles[0].total_cycles,
            pricing_scheme: {
              fixed_price: {
                value: selectedPlan.billing_cycles[0].pricing_scheme.fixed_price.value,
                currency_code: selectedPlan.billing_cycles[0].pricing_scheme.fixed_price.currency_code,
              },
            },
          },
        ],
        payment_preferences: {
          auto_bill_outstanding: true,
          setup_fee: {
            value: "0",
            currency_code: selectedPlan.billing_cycles[0].pricing_scheme.fixed_price.currency_code,
          },
          setup_fee_failure_action: "CANCEL",
          payment_failure_threshold: 3,
        },
        taxes: {
          percentage: "0",
          inclusive: "false",
        },
      };

      const planResponse = await gateway.post("/paypal/plans", planData, {
        headers: {
          Authorization: `${token}`,
        },
      });
      if (planResponse.status === 201) {
        handleOpenDialog();
      }
    } catch (error) {
      console.log(error);
      //setOpen(false);
    }
  };

  return (
    <Box
      sx={{
        p: 4,
        borderRadius: 1,
        backgroundColor: "#white",
        display: "flex",
        flexDirection: "column",
        padding: "20px",
        alignItems: "center",
        transition: "opacity 1s ease-in-out",
        boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
        height: "auto",
        marginTop: 4,
        width: { xs: "100%", sm: 500 },
      }}
    >
      <Typography textAlign="center" fontWeight="bold" mb={2}>
        Add new promo discount
      </Typography>
      <Box
        sx={{
          backgroundColor: "var(--fx-surface-base, #FFFFFF)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          borderRadius: 1,
          height: "auto",
          padding: "10px",
        }}
        component="form"
        onSubmit={createPromoDiscount}
      >
        <TextField select label="Select the base plan" onChange={handleSelectPlan} required fullWidth variant="outlined" margin="normal" size="small">
          {basePlans.map((item, index) => (
            <MenuItem key={index} value={item.paypalPlanId}>
              {item.name}
            </MenuItem>
          ))}
        </TextField>
        <TextField label="Promo code" name="promoCode" required margin="normal" size="small" fullWidth variant="outlined"></TextField>
        <TextField label="Price" name="price" type="number" required margin="normal" size="small" fullWidth variant="outlined"></TextField>
        <TextField
          label="Promo duration"
          name="intervalCount"
          type="number"
          required
          margin="normal"
          size="small"
          fullWidth
          variant="outlined"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip title="The special pricing is available for a total of [X] periods. After this period, the price will revert to the original amount">
                  <Help fontSize="10px" />
                </Tooltip>
              </InputAdornment>
            ),
          }}
        ></TextField>
        <Button type="submit" variant="contained" color="primary" size="small" sx={{ mt: 2, mb: 2, width: 250 }}>
          Create promo discount
        </Button>
      </Box>
      <BaseDialog
        openState={openDialog}
        setOpenState={handleCloseDialog}
        disableScape={true}
        title={`PROMO CODE CREATED SUCCESSFULLY`}
        titleSx={styles.titleConnectionSx}
        content={`Promo code "${promoCode}" was applied to ${planName} plan`}
        contentSx={styles.contentSx}
        actionSx={styles.actionSx}
        actions={[
          {
            label: "Return Home",
            onClick: () => {
              handleCloseDialog();
            },
            style: styles.btnCloseSx,
            autoFocus: true,
          },
        ]}
      ></BaseDialog>
      <LoaderComponent open={open} type="spinner"></LoaderComponent>
    </Box>
  );
};

export const EditPromoCode = ({ id, promoCode, setOpenDialog = () => { }, resetDetails = () => { } }) => {
  const [open, setOpen] = useState(false);
  const [codeDiscount, setCodeDiscount] = useState(promoCode);
  const [planPromoPrice, setPlanPromoPrice] = useState("");
  const [initialPrice, setInitialPrice] = useState("");
  const [price, setPrice] = useState("");
  const token = sessionStorage.getItem("token");

  const handleCodeChange = (e) => {
    setCodeDiscount(e.target.value);
  };

  const handleChangePrice = (e) => {
    setPrice(e.target.value);
  };

  const updatePromoDiscount = async (e) => {
    e.preventDefault();
    try {
      setOpen(true);
      const planDiscountObject = {
        description: "Promo discount plan",
        name: codeDiscount,
        taxPercentage: "0",
        autoBillOutstanding: true,
        paymentFailureThreshold: 7,
        promoCodeDiscount: codeDiscount,
      };

      if (initialPrice !== price) {
        planDiscountObject.pricingSchemes = [
          {
            billingCycleSequence: 1,
            pricingScheme: {
              fixedPrice: {
                value: price,
                currencyCode: planPromoPrice?.pricing_scheme?.fixed_price?.currency_code,
              },
            },
          },
        ];
      }

      await gateway.patch(`/paypal/plans/${id}`, planDiscountObject, {
        headers: {
          Authorization: `${token}`,
        },
      });

      setOpenDialog();
      resetDetails();
    } catch (error) {
      console.log(error);
    } finally {
      setOpen(false);
    }
  };

  const getPlanPromoDetails = async () => {
    const response = await gateway.get(`/paypal/plans/${id}`, {
      headers: {
        Authorization: `${token}`,
      },
    });
    const promoDiscountPrice = response?.data?.data?.billing_cycles.find((item) => item?.tenure_type === "TRIAL");
    setPlanPromoPrice(promoDiscountPrice);
    setInitialPrice(promoDiscountPrice?.pricing_scheme?.fixed_price?.value);
    setPrice(promoDiscountPrice?.pricing_scheme?.fixed_price?.value);
  };

  useEffect(() => {
    getPlanPromoDetails();
  }, []);

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 1,
        backgroundColor: "#white",
        display: "flex",
        flexDirection: "column",
        padding: "10px",
        alignItems: "center",
        transition: "opacity 1s ease-in-out",
        boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
        height: "auto",
        marginTop: 4,
        width: { xs: "100%", sm: 500 },
      }}
    >
      <Typography textAlign="center" fontWeight="bold" mb={2}>
        Update Promo Discount
      </Typography>
      <Box
        sx={{
          backgroundColor: "var(--fx-surface-base, #FFFFFF)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          borderRadius: 1,
          height: "auto",
          padding: "10px",
        }}
        component="form"
        onSubmit={updatePromoDiscount}
      >
        <TextField label="Promo code" name="planName" required value={codeDiscount} onChange={handleCodeChange} margin="normal" size="small" fullWidth variant="outlined"></TextField>
        <TextField
          margin="normal"
          required
          id="outlined-helperText"
          label="Price"
          name="price"
          size="small"
          fullWidth
          type="number"
          variant="outlined"
          sx={{
            fontSize: "12px",
          }}
          onChange={handleChangePrice}
          value={price}
        />
        <Button type="submit" variant="contained" color="primary" size="small" sx={{ mt: 2, mb: 2, width: 250 }}>
          UPDATE
        </Button>
      </Box>
      <LoaderComponent open={open} type="spinner"></LoaderComponent>
    </Box>
  );
};
